<template>
  <div v-loading="loading" class="evaluation-evaluators-table">
    <search-input
      placeholder="Поиск по ФИО"
      style="width: 300px"
      v-model="filters.search"
      @change="filtersChanged"
    >
    </search-input>
    <el-select
      style="width: 300px; margin-left: 20px"
      v-model="filters.statuses"
      size="size"
      multiple="multiple"
      placeholder="Статус"
      @change="filtersChanged"
      filterable
    >
      <el-option
        key="available"
        label="Доступен к оценке"
        value="available"
      />
      <el-option
        key="done"
        label="Оценка завершена"
        value="done"
      />
    </el-select>
    <el-button
      style="margin-left: 30px"
      class="button-icon-green"
      type="text"
      icon="fas fa-file-excel"
      :loading="loadingXls"
      @click="exportToExcel"
    >
      Экспорт в XLSX
    </el-button>
    <div class="evaluation_evaluators-block">
      <el-table :data="evaluation_evaluators" border>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column width="130" v-if="evaluation.setting" label="Все">
          <template v-slot="scope">
            <el-button
              size="mini"
              icon="fas fa-list-alt"
              @click="showEvaluators('all', scope.row.user_id)"
            >
              {{ scope.row.evaluators_info.all.evaluated_count }}/{{ scope.row.evaluators_info.all.all_count }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="130" v-if="evaluation.setting && evaluation.setting.is_self" label="Самооценка">
          <template v-slot="scope">
            <el-button
              size="mini"
              icon="fas fa-list-alt"
              @click="showEvaluators('self', scope.row.user_id)"
            >
              {{ scope.row.evaluators_info.self.evaluated_count }}/{{ scope.row.evaluators_info.self.all_count }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="130" v-if="evaluation.setting && evaluation.setting.is_colleague" label="Коллеги">
          <template v-slot="scope">
            <el-button
              size="mini"
              icon="fas fa-list-alt"
              @click="showEvaluators('colleague', scope.row.user_id)"
            >
              {{ scope.row.evaluators_info.colleague.evaluated_count }}/{{ scope.row.evaluators_info.colleague.all_count }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="130" v-if="evaluation.setting && evaluation.setting.is_subordinate" label="Подчиненные">
          <template v-slot="scope">
            <el-button
              size="mini"
              icon="fas fa-list-alt"
              @click="showEvaluators('subordinate', scope.row.user_id)"
            >
              {{ scope.row.evaluators_info.subordinate.evaluated_count }}/{{ scope.row.evaluators_info.subordinate.all_count }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="130" v-if="evaluation.setting && evaluation.setting.is_chief" label="Руководитель">
          <template v-slot="scope">
            <el-button
              size="mini"
              icon="fas fa-list-alt"
              @click="showEvaluators('chief', scope.row.user_id)"
            >
              {{ scope.row.evaluators_info.chief.evaluated_count }}/{{ scope.row.evaluators_info.chief.all_count }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="Результат" width="180">
          <template v-slot="scope">
            <el-button
              v-if="scope.row.status === 'done' || evaluation.status === 'finished'"
              size="mini"
              icon="fas fa-list-alt"
              @click="showEvaluateResult(scope.row.user, scope.row.evaluation_id)"
            >
              Смотреть
            </el-button>
            <p v-else>Нет результата оценки</p>
          </template>
        </el-table-column>
        <el-table-column width="230" label="Статус">
          <template v-slot="scope">
            <span class="status" :class="scope.row.status === 'done' ? 'done' : 'in_progress'">{{ scope.row.evaluators_info.status }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadEvaluationEvaluators"
    ></paginator>

    <eval-evaluation-evaluators-show-dialog ref="showEvaluators" @load-evaluation-evaluators="loadEvaluationEvaluators"></eval-evaluation-evaluators-show-dialog>

    <evaluate-result-dialog
      ref="evaluateResultDialog"
    >
    </evaluate-result-dialog>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import EvalEvaluationEvaluatorsShowDialog from "@/modules/evaluation/components/evaluation/EvalEvaluationEvaluatorsShowDialog.vue";
import EvaluateResultDialog from "@/modules/evaluation/components/evaluation/EvaluateResultDialog.vue";
import {downloader} from "@/mixins/downloader";

export default {
  name: "evaluation-evaluators-table",
  components: {EvaluateResultDialog, EvalEvaluationEvaluatorsShowDialog, SearchInput, Paginator},
  data() {
    return {
      loading: false,
      evaluation_evaluators: [],
      filters: {},
      loadingXls: false,
    }
  },
  props: {
    evaluation: {
      type: Object,
      default: {},
    },
  },
  mixins: [paginator, downloader],
  mounted() {
    this.loadEvaluationEvaluators();
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    exportToExcel() {
      this.loadingXls = true;
      this.downloadFile(
        this.evaluation.name + '.xlsx',
        this.$api.exportImport.export,
        {
          entity: 'evaluation',
          data: {
            id: this.$route.params.id
          }}
      )
        .finally(()=>{
          this.loadingXls = false;
        })
    },
    showEvaluators(type, userId) {
      this.$refs.showEvaluators.open(type, userId, this.evaluation);
    },
    showEvaluateResult(user, evaluationId) {
      this.$refs.evaluateResultDialog.open(user, evaluationId);
    },
    loadEvaluationEvaluators() {
      this.loading = true;
      this.$api.evaluation.evaluationUserSearch({
        ...this.filters,
        expand: ['user', 'evaluators_info'].join(),
        only_members: true,
        evaluation_id: this.$route.params.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluation_evaluators = data.evaluation_users;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    filtersChanged() {
      this.loadEvaluationEvaluators();
    },
  }
}
</script>

<style scoped lang="scss">
  .evaluation-evaluators-table {
    .evaluation_evaluators-block {
      margin: 25px 0;
    }

    .status {
      color: white;
      margin: 5px;
      border-radius: 10px;
      padding: 5px 10px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: bold;
    }

    .status.done {
      background-color: #64d074;
    }

    .status.in_progress {
      background-color: #f3ae7b;
    }
  }
</style>